/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import DTOEmpTrainingDetails from "./DTOEmpTrainingDetails";
import EmpTrainingDetailModalPresenter from "./EmpTrainingDetailModalPresenter";
import { useTranslation } from "react-i18next";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  viewScheduled: any;
}
const EmpTrainingDetailsModalController = ({
  isModalOpen,
  closeModal,
  viewScheduled,
}: ModalInterface) => {
  const { t, i18n } = useTranslation();
  return (
    <>
      <EmpTrainingDetailModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        viewScheduled={viewScheduled}
        trans={t}
        i18n={i18n}
      />
      <DTOEmpTrainingDetails />
    </>
  );
};
export default EmpTrainingDetailsModalController;
